module.exports = __webpack_public_path__ + "static/media/0323_IMG_TRAD_LE_SOL_MEGALITH_MEGABLACK.cd14fbc1.webp";